import { Cookies } from 'react-cookie';

import axiosInterceptor from 'api/interceptor/axiosClient';

export interface DeleteDigestReportInterface {
  slug: string;
  id: number;
}

export const deleteDigestReport = async ({ slug, id }: DeleteDigestReportInterface) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.delete(`/objects/${slug}/technician-digests/${id}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as any;
};
